import React from 'react'
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const ChooseUs = () => {
    return (
        <>
            <section className='choose_us'>
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 text-md-center mb-4 mb-md-5">
                            <span className='span_head'>Why choose us</span>
                            <h3 className='heading mt-3'>Still Thinking About your Decision to Hire Us?</h3>
                            <div className="heading-divider mb-4"></div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="card p-3 p-md-4 border-0 mb-4 mb-lg-3 h-100" style={{borderRadius:'15px',backgroundColor:'var(--gray-background)'}}>
                                {/* <div className='me-3 me-md-3'>
                                    <img src="./images/customer-review.png" alt="Website Designing Service Company in Delhi" />
                                </div> */}
                                <div>
                                    <h4>Decades of Expertise</h4>
                                    <p className='m-0'>With more than 13 years of experience, Our team is passionate and adapts to the latest industry standards.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="card p-3 p-md-4 border-0 mb-4 mb-lg-3 h-100" style={{borderRadius:'15px',backgroundColor:'var(--gray-background)'}}>
                                {/* <div className='me-3 me-md-3'>
                                    <img src="./images/website-design.png" alt="Website Designing Service Company in Delhi" />
                                </div> */}
                                <div>
                                    <h4>Customized Web Designs</h4>
                                    <p className='m-0'>Every business has unique needs, so we offer customized services. Our web designers and developers make each website according to your specifications.</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-3 d-none d-lg-block">
                            <img src="./images/choose.webp" className='w-100' alt="Why choose us" />
                        </div> */}
                        <div className="col-md-6 mb-3">
                            <div className="card p-3 p-md-4 border-0 mb-4 mb-lg-3 h-100" style={{borderRadius:'15px',backgroundColor:'var(--gray-background)'}}>
                                {/* <div className='me-3 me-md-3'>
                                    <img src="./images/guarantee.png" alt="Website Designing Service Company in Delhi" />
                                </div> */}
                                <div>
                                    <h4>100% Satisfaction</h4>
                                    <p className='m-0'>We have built a professional relationship with hundreds of clients. Our services are offered to all industry verticals.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="card p-3 p-md-4 flex-row align-items-center border-0 h-100" style={{borderRadius:'15px',backgroundColor:'var(--gray-background)'}}>
                                {/* <div className='me-3 me-md-3'>
                                    <img src="./images/brand.png" alt="Website Designing Service Company in Delhi" />
                                </div> */}
                                <div>
                                    <h4>Reliability</h4>
                                    <p className='m-0'>Our services are reliable and help to create trust in the business amongst the clients and allow them to approach you.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                

                    {/* <div className="card-group counters">
                        <div className="card text-center p-3 p-md-4">
                            <div className='counter heading'>
                            <CountUp end={1500}>
                                {({ countUpRef, start }) => (
                                <VisibilitySensor onChange={start}>
                                    <span ref={countUpRef} />
                                </VisibilitySensor>
                                )}
                            </CountUp>+
                            </div>
                            <h6>PROJECTS COMPLETED</h6>
                        </div>
                        <div className="card text-center p-3 p-md-4">
                            <div className='counter heading'>
                                <CountUp end={1400}>
                                    {({ countUpRef, start }) => (
                                    <VisibilitySensor onChange={start}>
                                        <span ref={countUpRef} />
                                    </VisibilitySensor>
                                    )}
                                </CountUp>+
                            </div>
                            <h6>HAPPY CUSTOMERS</h6>
                        </div>
                        <div className="card text-center p-3 p-md-4">
                            <div className='counter heading'>
                                <CountUp end={100}>
                                    {({ countUpRef, start }) => (
                                    <VisibilitySensor onChange={start}>
                                        <span ref={countUpRef} />
                                    </VisibilitySensor>
                                    )}
                                </CountUp>%
                            </div>
                            <h6>SUCCESS RATE</h6>
                        </div>
                        <div className="card text-center p-3 p-md-4">
                            <div className='counter heading'>
                                <CountUp end={13}>
                                    {({ countUpRef, start }) => (
                                    <VisibilitySensor onChange={start}>
                                        <span ref={countUpRef} />
                                    </VisibilitySensor>
                                    )}
                                </CountUp>+
                            </div>
                            <h6>YEARS OF EXPERIENCE</h6>
                        </div>
                    </div> */}
            </section>
             
        </>
    )
}

export default ChooseUs